/**
 * Camera zoom range (DROW-181). Kept free of three.js so the settings store (main chunk) can
 * import it without pulling in the game chunk. Zoom Z makes everything Z× bigger on screen.
 */
export const ZOOM_MIN = 1;
/** The most zoom that keeps 720 sim visible above and below the warlock with touch framing. */
export const ZOOM_MAX = 1.25;
export const ZOOM_STEP = 0.05;
/** Mobile default: about 20% bigger warlocks and projectiles than desktop. */
export const MOBILE_ZOOM_DEFAULT = 1.2;

/** Clamp to ZOOM_MIN..ZOOM_MAX and snap to ZOOM_STEP; anything that isn't a finite number → default. */
export function clampZoom(v: unknown, fallback = MOBILE_ZOOM_DEFAULT): number {
  if (typeof v !== 'number' || !Number.isFinite(v)) return fallback;
  const snapped = Math.round(v / ZOOM_STEP) * ZOOM_STEP;
  return Math.round(Math.min(ZOOM_MAX, Math.max(ZOOM_MIN, snapped)) * 100) / 100;
}
